import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { useState, Fragment as Fragment$1 } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';

const Feedback = _ref => {
  let {
    type,
    message
  } = _ref;
  var _a;
  const label = useLabel();
  const threadId = useLlm(state => state.threadId) || '';
  const messageId = message.messageId || '';
  const {
    getApi
  } = useLlm(state => state.actions);
  const theme = useLlm(state => state.theme);
  const [valid, setValid] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState();
  const feedbackType = type || ((_a = theme.feedback) === null || _a === void 0 ? void 0 : _a.type) || 'stars';
  const classNames = getClassNames('llm__feedback', `llm__feedback--${feedbackType}`);
  /*
  const [feedbackRating, setFeedbackRating] = useState<number>();
  const onRating = async (event: ChangeEvent<HTMLInputElement>) => {
    console.log(event.currentTarget);
    const value = String(event.currentTarget.value);
    const rating = parseInt(value);
    setFeedbackRating(rating);
  };
  */
  const onSubmit = event => __awaiter(void 0, void 0, void 0, function* () {
    event.preventDefault();
    try {
      setError(undefined);
      const formData = new FormData(event.currentTarget);
      const data = {
        threadId,
        messageId
      };
      for (const [key, value] of formData) {
        switch (key) {
          case 'feedbackRating':
            data[key] = parseInt(String(value));
            break;
          default:
            data[key] = String(value);
        }
      }
      const valid = Boolean(data.feedbackRating);
      // console.log('onSubmit', data.feedbackRating);
      if (valid) {
        const api = getApi();
        const response = yield api.postFeedback(data);
        if (response) {
          // console.warn('Feedback.onSubmit.success', response, data);
          setSubmitted(true);
        } else {
          // console.warn('Feedback.onSubmit.error');
          setError({
            message: 'unknown error'
          });
        }
      }
    } catch (error) {
      console.warn('Feedback.onSubmit.error', error);
      setError(error);
    }
  });
  const onChange = event => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData(event.currentTarget);
    const data = {
      threadId,
      messageId
    };
    for (const [key, value] of formData) {
      switch (key) {
        case 'feedbackRating':
          data[key] = parseInt(String(value));
          break;
        default:
          data[key] = String(value);
      }
    }
    const valid = Boolean(data.feedbackRating);
    // console.log('onChange', data.feedbackRating);
    setValid(valid);
  });
  if (!threadId) {
    return;
  }
  if (!messageId) {
    return;
  }
  return jsx("div", {
    className: classNames,
    children: jsx("div", {
      className: "llm__row",
      children: jsx("div", {
        className: "llm__col --sm-10 --sm-9 --md-8 --lg-7 --xl-6",
        children: jsx("div", {
          className: "llm__feedback__group",
          children: error ? jsx("div", {
            className: "llm__feedback__title",
            children: label('llm.feedbackError')
          }) : submitted ? jsx("div", {
            className: "llm__feedback__title",
            children: label('llm.feedbackSent')
          }) : jsxs(Fragment, {
            children: [jsx("div", {
              className: "llm__feedback__title",
              children: label('llm.feedbackTitle')
            }), jsxs("form", {
              id: `feedback_${messageId}`,
              className: "llm__feedback__form",
              onSubmit: onSubmit,
              onChange: onChange,
              children: [jsxs("fieldset", {
                className: "llm__feedback__rating",
                children: [jsx("legend", {
                  children: label('llm.feedbackRating')
                }), jsx("div", {
                  className: "llm__feedback__stars",
                  children: new Array(5).fill(0).map((_, i) => jsxs(Fragment$1, {
                    children: [jsx("input", {
                      type: "radio",
                      name: "feedbackRating",
                      id: `feedbackRating_${messageId}_${i + 1}`,
                      value: i + 1
                    }), jsx("label", {
                      htmlFor: `feedbackRating_${messageId}_${i + 1}`,
                      children: jsxs("span", {
                        children: ["$", i + 1]
                      })
                    })]
                  }, i))
                })]
              }), jsxs("fieldset", {
                className: "llm__feedback__message",
                children: [jsx("legend", {
                  children: label('llm.feedbackMessage')
                }), jsx("input", {
                  type: "text",
                  name: "feedbackMessage",
                  id: "feedbackMessage",
                  placeholder: label('llm.feedbackMessagePlaceholder')
                })]
              }), jsx("div", {
                className: "llm__feedback__cta",
                children: jsx("button", {
                  type: "submit",
                  disabled: !valid,
                  children: label('llm.feedbackSend')
                })
              })]
            })]
          })
        })
      })
    })
  });
};

export { Feedback };
//# sourceMappingURL=feedback.js.map
